<template>
    <el-container class="api-page" v-wechat-title="$route.meta.title">
        <el-container class="api-main">
            <el-main>
                <div class="api-header column-header">
                    <span><i class="fa fa-th-list" aria-hidden="true"></i> API 列表</span>
                    <el-button class="btn__style" @click="showDialog">添加API</el-button>
                </div>
                <div class="api-body">
                    <div class="api-body-title">
                        <div>
                            <span>ID</span>
                        </div>
                        <div>
                            <span>API名</span>
                        </div>
                        <div>
                            <span>USDT 趋势</span>
                        </div>
                        <div>
                            <span>交易所</span>
                        </div>
                        <div>
                            <span>状态</span>
                        </div>
                        <div>
                            <span>操作</span>
                        </div>
                    </div>
                    <div class="api-body-content">
                        <ApiInfo v-for="(api, index) in apiList" :key="'api-'+index" :apiData="api" @showApiInfo="showApiInfo" 
                        @showBaseApiInfo="showBaseApi" @advanceSetting="showAdvanceSetting" @showAssetTemplate="showAssetTemplate"></ApiInfo>
                    </div>
                </div>
                <!--高级设置页面-->
                <el-dialog class="api-step" :visible.sync="stepsDialogVisible" width="30%">
                    <div class="dialog-title">
                        <h3>API 高级设置</h3>
                    </div>
                    <el-divider></el-divider>
                    <el-form :label-position="labelPosition" label-width="140px" v-if="AdvanceFlag">
                        <el-form-item label="是否可以借贷">
                            <el-switch v-model="apiIsBorrow"></el-switch>
                        </el-form-item>
                        <el-form-item label="是否自动还款">
                            <el-switch v-model="apiIsRepayment"></el-switch>
                        </el-form-item>
                        <el-form-item label="杠杆借贷保证金率" id="form-bottom">
                            <StepProgress v-model="leverRisk"
                            :min="0.2" :max="2" :step="0.01">
                            </StepProgress>
                        </el-form-item>
                        <el-form-item label="总保证金多的倍数" id="form-bottom">
                            <StepProgress v-model="x"
                            :min="0" :max="20" :step="1">
                            </StepProgress>
                        </el-form-item>
                        <el-form-item label="现货多的保证金倍数" id="form-bottom">
                            <StepProgress v-model="x1"
                            :min="0" :max="20" :step="1" @input="sliderEvent(x1, '1')">
                            </StepProgress>
                        </el-form-item>
                        <el-form-item label="期货多的保证金倍数" id="form-bottom">
                            <StepProgress v-model="x2"
                            :min="1" :max="20" :step="1" @input="sliderEvent(x2, '2')">
                            </StepProgress>
                        </el-form-item>
                    </el-form>
                    <el-divider></el-divider>
                    <div class="dialog-footer">
                        <el-button @click="submitAdvanceSettting(advanceApi)">确认</el-button>
                    </div>
                </el-dialog>
                <el-dialog :visible.sync="apiDialogVisible" width="30%">
                    <div class="dialog-title">
                        <h3>API 手续费配置</h3>
                    </div>
                    <el-divider></el-divider>
                    <el-form :label-position="labelPosition" label-width="140px">
                        <el-form-item label="现货挂单手续费">
                            <el-input v-model="apiCharges.ssHangCharges"></el-input>
                        </el-form-item>
                        <el-form-item label="现货吃单手续费">
                            <el-input v-model="apiCharges.ssEatCharges"></el-input>
                        </el-form-item>
                        <el-form-item label="交割合约挂单手续费">
                            <el-input v-model="apiCharges.fuHangCharges"></el-input>
                        </el-form-item>
                        <el-form-item label="交割合约吃单手续费">
                            <el-input v-model="apiCharges.fuEatCharges"></el-input>
                        </el-form-item>
                        <el-form-item label="永续合约挂单手续费">
                            <el-input v-model="apiCharges.csHangCharges"></el-input>
                        </el-form-item>
                        <el-form-item label="永续合约吃单手续费">
                            <el-input v-model="apiCharges.csEatCharges"></el-input>
                        </el-form-item>
                        <el-form-item label="最大亏损">
                            <el-input v-model="apiCharges.maxLoss"></el-input>
                        </el-form-item>
                    </el-form>
                    <el-divider></el-divider>
                    <div class="dialog-footer">
                        <el-button @click="submitConfig">确认</el-button>
                    </div>
                </el-dialog>

                <el-dialog :visible.sync="addDialogVisible" width="50%">
                    <div class="dialog-header">
                        <h3 v-if="dialogFlag == 'add'">添加API</h3>
                        <h3 v-else>API秘钥配置</h3>
                    </div>
                    <el-divider></el-divider>
                    <div class="dialog-content">
                        <form>
                            <div class="form-item">
                                <label>交易所</label>
                                <select aria-placeholder="填写交易所名称" v-model="bourseId">
                                    <option v-for="(item, index) in bourseList" :key="index" :value="index">{{item}}</option>
                                </select>
                            </div>
                            <div class="form-item">
                                <label>策略</label>
                                <select v-model="apiStrategy">
                                    <option value="1">对冲</option>
                                    <option value="4">单边</option>
                                </select>
                            </div>
                            <div class="form-item">
                                <label>API名称</label>
                                <input type="text" v-model="name" placeholder="请填写api名称">
                            </div>
                            <div class="form-item">
                                <label>交易所公钥</label>
                                <input type="text" v-model="apiKey" placeholder="填写交易所公钥">
                            </div>
                            <div class="form-item">
                                <label>交易所私钥</label>
                                <input type="text" v-model="apiSecret" placeholder="填写交易所公钥">
                            </div>
                            <div class="form-item">
                                <label>其他</label>
                                <input type="text" v-model="apiToken" placeholder="填写token(没有可以不填)">
                            </div>
                        </form>
                    </div>
                    <el-divider></el-divider>
                    <div class="dialog-footer">
                        <el-button v-if="dialogFlag == 'add'" @click="submitApi">提交</el-button>
                        <el-button v-else @click="modifyApi">修改</el-button>
                    </div>
                </el-dialog>
                <el-dialog :visible.sync="assetTemplateDialogVisible" width="50%">
                    <div class="dialog-header">
                        <h3>修改本金</h3>
                    </div>
                    <el-divider></el-divider>
                    <div class="dialog-content">
                        <form>
                            <div class="form-item">
                                <label>本金(USDT)</label>
                                <input type="number" v-model="assetTemplate" placeholder="非0, 不要太小" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')">
                            </div>
                        </form>
                    </div>
                    <el-divider></el-divider>
                    <div class="dialog-footer">
                        <el-button @click="updateAssetTemplate">确定</el-button>
                    </div>
                </el-dialog>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
/* eslint-disable */
import AddApi from '@/views/api/Add-api.vue'
import ApiInfo from '@/views/api/Api-info.vue'
import StepProgress from "@/components/Step-progress.vue"
import { post, get, put } from '@/api/index'
import { mapState,mapActions } from 'vuex';

export default {
    data() {
        return{
            flag: false,
            apiDialogVisible: false,
            labelPosition: 'right',
            apiCharges: {},
            dialogApiId: '',
            chargesData: Object,
            addDialogVisible: false,
            stepsDialogVisible: false,
            assetTemplateDialogVisible: false,
            assetTemplate: 0,
            apiList: [],
            apiKey: '',
            apiSecret: '',
            apiToken: '',
            name: '',
            bourseList: [],
            bourseId: 1,
            dialogFlag: 'add',
            baseApiId: Number,
            value: 0,
            marks: {
                0.2: '0.2',
                2: '2'
            },
            marks1: {
                0: '0',
                20: '20'
            },
            marks2: {
                1: '1',
                20: '20'
            },
            apiIsBorrow: false,
            apiIsRepayment: false,
            apiAdvanceData: {},
            advanceApi: null,
            x: 1,
            x2: 1,
            x1: 1,
            leverRisk: 0.2,
            AdvanceFlag: false,
            apiStrategy: '4'
        }
    },
    components: {
        AddApi,
        ApiInfo,
        StepProgress
    },
    mounted() {
        this.getChartData();
        this.getApiList();
    },
    computed: {
        ...mapState([
            'userName',
            'token',
            'apiChartData'
        ]),
    },
    watch: {
        // 多次弹窗组件只加载一次问题
        stepsDialogVisible: function () {
            if (this.stepsDialogVisible) {
                this.AdvanceFlag = true;
            } else {
                this.AdvanceFlag = false;
            }
        }
    },
    methods: {
        ...mapActions([
            'getBourseList',
            'getChartData'
        ]),

        // 展示api信息窗口
        showApiInfo(apiId) {
            this.dialogApiId = apiId;
            this.getApiCharges(apiId);
            this.apiDialogVisible = true;
        },

        // 获取api列表
        getApiList() {
            let url = this.$baseUrl + '/api/list';
            let param = {
                'token': this.token
            };

            get(url, param).then(resp => {
                if (resp.code == 200) {
                    this.apiList = resp.data;
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        // 修改 api 手续费
        submitConfig() {
            this.apiCharges['token'] = this.token;
            this.apiCharges['apiId'] = this.dialogApiId;
            var url = this.$baseUrl + '/api/charges/update';
            post(url, JSON.stringify(this.apiCharges)).then(resp => {
                if (resp.code == 200) {
                    this.$notify.info({
                        message: '修改成功',
                        title: '提示',
                        offset: 100
                    })
                    this.apiDialogVisible = false;
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        // 获取api手续费
        getApiCharges(apiId) {
            var url = this.$baseUrl + '/api/charges/get';
            var param = {
                'token': this.token,
                'apiId': apiId
            };
            get(url, param).then(resp => {
                if (resp.code == 200) {
                    this.apiCharges = resp.data;
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100,
                        duration: 1000
                    })
                }
            })
        },

        // 添加api
        showDialog() {
            this.dialogFlag = 'add';
            this.getBourseList().then(data => {
                this.bourseList = data;
            })
            this.addDialogVisible = true
        },

        // 添加 api
        submitApi() {
            let url = this.$baseUrl + '/api/add';
            let param = {
                'token': this.token,
                'name': this.name,
                'bourseId': this.bourseId,
                'apiKey': this.apiKey,
                'apiSecret': this.apiSecret,
                'apiToken': this.apiToken,
                'status': this.apiStrategy
            };
            console.log(param)
            post(url, JSON.stringify(param)).then(resp => {
                if (resp.code == 200) {
                    this.$notify.info({
                        message: '添加成功',
                        title: '提示',
                        offset: 100
                    })
                    // 刷新列表
                    this.getApiList();
                    this.addDialogVisible = false;
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        // 展示api 密匙等信息
        showBaseApi(apiId) {
            this.dialogFlag = 'config';
            this.baseApiId = apiId;
            this.getBourseList().then(data => {
                this.bourseList = data;
            })
            this.addDialogVisible = true;
        },

        // 修改 api 秘钥信息
        modifyApi() {
            var url = this.$baseUrl + '/api/update';
            var param = {
                'token': this.token,
                'apiId': this.baseApiId,
                'name': this.name,
                'bourseId': this.bourseId,
                'apiKey': this.apiKey,
                'apiSecret': this.apiSecret,
                'apiToken': this.apiToken,
                'status': this.apiStrategy
            };
            put(url, JSON.stringify(param)).then(resp => {
                console.log(resp);
                if (resp.code == 200) {
                    this.$notify.info({
                        message: '修改成功',
                        title: '提示',
                        offset: 100,
                        duration: 1000
                    })
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100,
                        duration: 1000
                    })
                }
            })
        },

        showAssetTemplate(apiId) {

            let url = this.$baseUrl + '/api/asset/template';
            let param = {
                'token': this.token,
                'apiId': apiId,
            };

            get(url, param).then(resp => {
                if (resp.code == 200) {
                    this.assetTemplate = resp.data;
                    this.dialogApiId = apiId;
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })

            this.assetTemplateDialogVisible = true
        },

        updateAssetTemplate() {
            var url = this.$baseUrl + '/api/asset/template';
            var param = {
                'token': this.token,
                'apiId': this.dialogApiId,
                'assetTemplate': this.assetTemplate,
            };
            post(url, JSON.stringify(param)).then(resp => {
                console.log(resp);
                if (resp.code == 200) {
                    this.$notify.info({
                        message: '修改成功',
                        title: '提示',
                        offset: 100,
                        duration: 1000
                    })
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100,
                        duration: 1000
                    })
                }
            })
            this.assetTemplateDialogVisible = false;
        },

        // 高级设置页面展示
        showAdvanceSetting(apiId) {
            this.getAdvanceSetting(apiId).then((data) =>{
                this.advanceApi = apiId;
                this.stepsDialogVisible = true;
                this.AdvanceFlag = true;
            })
        },

        // 获取高级配置信息
        getAdvanceSetting(apiId) {
            let url = this.$baseUrl + '/api/advanced/setup/get';
            let paramObj = {
                'token': this.token,
                'apiId': apiId
            };

            return new Promise((resolve, reject) => {
                get(url, paramObj).then(resp => {
                    if (resp.code == 200) {
                        let data = resp.data;
                        this.apiIsBorrow = data.is_borrow;
                        this.apiIsRepayment = data.is_auto_repayment;
                        this.x = data.total_deposit_multiple;
                        this.x1 = data.proportion_ratio_spot;
                        this.x2 = data.proportion_ratio_deposit;
                        this.leverRisk = data.lever_risk_rate;
                        this.apiAdvanceData = data;
                        resolve(resp.data);
                    } else {
                        this.$notify.error({
                            message: resp.info,
                            title: '提示',
                            offset: 100,
                            duration: 1000
                        })
                    }
                })
            })
        },

        // 滑动条事件
        sliderEvent(data, flag) {
            if (flag == '1') {
                this.x = this.x1 + this.x2;
                if (this.x > 20) {
                    this.x2 = 20 - this.x1;
                }
            } else {
               this.x = data + this.x1;
                if (this.x > 20) {
                    this.x1 = 20 - data;
                } 
            }
        },

        // 提交高级配置信息
        submitAdvanceSettting(apiId) {
            let url = this.$baseUrl + '/api/advanced/setup/update';
            let paramObj = {
                'token': this.token,
                'apiId': apiId,
                'total_deposit_multiple': this.x,
                'proportion_ratio_spot': this.x1,
                'proportion_ratio_deposit': this.x2,
                'is_borrow': this.apiIsBorrow,
                'is_auto_repayment': this.apiIsRepayment,
                'lever_risk_rate': this.leverRisk
            };

            put(url, JSON.stringify(paramObj)).then(resp => {
                if (resp.code == 200) {
                    this.stepsDialogVisible = false;
                    this.$notify.info({
                        message: '配置成功',
                        title: '提示',
                        offset: 100,
                        duration: 1000
                    })
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100,
                        duration: 1000
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss">
    .el-container{
        // margin-top: 2%;
        .el-container{
            margin-top: 0;
        }
    }
    .api-page{
        .active1{
            background-color: #1e1e1e;
            color: #fff;
        }
        
        .active-background-color{
            color: #1e1e1e;
            background-color: #1e1e1e;
        }
        .el-container{
            width: 100%;
            // margin: 20px auto;
            min-height: 580px;
        }
        .api-footer{
            position: relative;
            bottom: 0;
        }
        .el-menu{
            background-color: #1e1e1e;
        }
        .api-main{
            padding: 0;
            padding-bottom: 56px;
            .el-main{
                // padding: 15px 0;
                background-color: #262829;
                .api-header{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    background-color: #1e1e1e;
                }
                .api-body{
                    color: #787979;
                    // margin-top: 5px;
                    padding: 5px 3px;
                    
                    .api-body-title{
                        display: flex;
                        padding: 10px 0px;
                        background-color: #212223;
                        div{
                            flex: 1;
                        }
                    }
                }
                .el-dialog{
                    .dialog-header{
                        padding: 10px;
                    }
                    .dialog-content{
                        margin-top: 10px;
                        form{
                            width: 60%;
                            margin: 0 auto;
                            min-width: 330px;
                            .form-item{
                                display: flex;
                                justify-content: flex-start;
                                label{
                                    min-width: 80px;
                                    margin-right: 20px;
                                    text-align: right;
                                    height: 30px;
                                    line-height: 30px;
                                }
                                input{
                                    height: 30px;
                                    margin-bottom: 10px;
                                    padding: 0 5px;
                                    width: 100%;
                                }
                                select{
                                    // width: 100px;
                                    margin-bottom: 10px;
                                    height: 30px;
                                    padding: 0 5px;
                                }
                            }
                        }
                    }
                    .dialog-title{
                        padding-top: 20px;
                        h3{
                            font-size: 20px;
                        }
                    }
                    .el-form{
                        padding: 10px;
                        width: 80%;
                        margin: 0 auto;
                        .el-form-item{
                            margin-bottom: 12px;
                        }
                    }
                    .el-input{
                        width: 60%;
                        font-size: 13px;
                    }
                    .dialog-footer{
                        padding: 10px; 
                        text-align: right;
                    }
                    .el-divider{
                        margin: 8px 0;
                    }
                }
                .el-dialog {
                    .el-form {
                        width: 90%;
                        #form-bottom {
                            .el-form-item__content {
                                margin-left: 160px !important;
                            }
                        }
                        .el-form-item {
                            .el-slider {
                                .el-slider__button {
                                    width: 12px;
                                    height: 12px;
                                }
                                .el-slider__marks {
                                    .el-slider__marks-text {
                                        min-width: 30px;
                                        margin-top: 5px;
                                    }
                                }
                            }
                        }
                    }
                }
                .api-step {
                    .el-form {
                        .el-form-item {
                            .slider-value {
                                position: absolute;
                                left: 50%;
                                top: 50%;
                                color: #828488;
                            }
                        }
                    }
                }
            }
            .el-aside{
                background-color: #262829;
                .aside-header{
                    padding: 20px;
                    border-bottom: 3px solid #252425;
                    .el-avatar{
                        width: 60px;
                        height: 60px;
                        font-size:  25px;
                        line-height: 60px;
                    }
                    .user-title{
                        padding: 5px;
                        color: #787979;
                    }
                }
                ul{
                    background-color: #262829;
                    border: 0;
                    li{
                        color: #787979;
                    }
                    li:hover{
                        background-color: #1e1e1e;
                    }
                }
            }
        }
        
    }

    @media screen and (max-width: 1100px) {
        .api-page{
            .el-container{
                padding: 10px 0;
                margin: 10px auto;
                width: 100%;
                .el-aside{
                    display: none;
                }
                .el-main{
                    margin: 0;
                    .el-dialog{
                        min-width: 350px !important;
                        .el-dialog__body{
                            .el-form{
                                width: 100%;
                                padding: 10px 0;
                                .el-form-item{
                                    margin-bottom: 5px;
                                    .el-form-item__label{
                                        font-size: 0.5rem;
                                        padding: 0;
                                    }
                                    .el-form-item__content{
                                        margin-left: 100px !important;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 420px) {
        .api-page{
            .el-container{
                padding: 10px 0;
                margin: 10px auto;
                width: 100%;
                .el-aside{
                    display: none;
                }
                .el-main{
                    width: 100%;
                    .api-body{
                        padding: 0;
                        // width: 375px;
                        // overflow-x: scroll;
                        margin-top: 10px;
                        .api-body-content{
                            .api-info{
                                font-size: 13px;
                                .api-info-item {
                                    padding: 5px 0;
                                    .el-dropdown-link {
                                        font-size: 12px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
